export default "__VITE_ASSET__d12e88ae__"